var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncidentLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 115314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4148",
    d: "M0 1.52588e-05H22.737V24.308H0V1.52588e-05Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59738_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4143",
    d: "M18.0251 11.246C18.0251 16.574 10.0321 24.308 10.0321 24.308C10.0321 24.308 2.03906 16.575 2.03906 11.246C2.03906 9.12611 2.88118 7.09306 4.38016 5.59409C5.87914 4.09511 7.9122 3.25299 10.0321 3.25299C12.1519 3.25299 14.185 4.09511 15.684 5.59409C17.1829 7.09306 18.0251 9.12611 18.0251 11.246Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4144",
    d: "M14.7161 11.195C14.7161 12.4367 14.2228 13.6276 13.3447 14.5057C12.4667 15.3837 11.2758 15.877 10.0341 15.877C9.41921 15.877 8.81039 15.7559 8.24234 15.5206C7.67429 15.2853 7.15815 14.9404 6.72339 14.5057C6.28862 14.0709 5.94373 13.5548 5.70844 12.9867C5.47314 12.4187 5.35205 11.8098 5.35205 11.195C5.35205 10.5801 5.47314 9.97131 5.70844 9.40326C5.94373 8.83521 6.28862 8.31907 6.72339 7.88431C7.15815 7.44954 7.67429 7.10468 8.24234 6.86938C8.81039 6.63409 9.41921 6.51299 10.0341 6.51299C11.2758 6.51299 12.4667 7.00626 13.3447 7.88431C14.2228 8.76235 14.7161 9.95325 14.7161 11.195Z",
    fill: "#ACACAC",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4145",
    d: "M21.2222 6.40599C21.2222 7.86468 20.6427 9.26362 19.6113 10.2951C18.5798 11.3265 17.1809 11.906 15.7222 11.906C14.2635 11.906 12.8645 11.3265 11.8331 10.2951C10.8016 9.26362 10.2222 7.86468 10.2222 6.40599C10.2222 4.9473 10.8016 3.54836 11.8331 2.51691C12.8645 1.48546 14.2635 0.905991 15.7222 0.905991C17.1809 0.905991 18.5798 1.48546 19.6113 2.51691C20.6427 3.54836 21.2222 4.9473 21.2222 6.40599Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4146",
    d: "M21.2222 6.40599C21.2222 7.86468 20.6427 9.26362 19.6113 10.2951C18.5798 11.3265 17.1809 11.906 15.7222 11.906C14.2635 11.906 12.8645 11.3265 11.8331 10.2951C10.8016 9.26362 10.2222 7.86468 10.2222 6.40599C10.2222 4.9473 10.8016 3.54836 11.8331 2.51691C12.8645 1.48546 14.2635 0.905991 15.7222 0.905991C17.1809 0.905991 18.5798 1.48546 19.6113 2.51691C20.6427 3.54836 21.2222 4.9473 21.2222 6.40599Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4147",
    d: "M13.0479 6.40599H18.3939",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentLocation);
export default __webpack_public_path__ + "static/media/incident-location.46213e3bdae16616d0ef74db16da4c59.svg";
export { ForwardRef as ReactComponent };